import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Vant from 'vant'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import bootstrap from '@/core/bootstrap'
import Loading from '@/components/Loading' // 全局加载组件挂载
import '@/utils/filter.js' // 全局过滤器
import GlobalComponents from '@/components/common/index' // 全局组件注册
import Util from '@/utils/util.js' // 全局公共方法

import 'vant/lib/index.css' // 有赞样式
import 'swiper/dist/css/swiper.css' // swiper样式
import waterfall from 'vue-waterfall2'

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: '5cDQwKAPkhYzkgXoQqvoI8BzTRt9qrRw'
})
Vue.prototype.$util = Util // 全局注册公共类方法

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Loading)
Vue.use(GlobalComponents) // 全局组件
Vue.use(VueAwesomeSwiper) // 轮播图
Vue.use(waterfall) // 瀑布流
// 全局混合器
Vue.mixin({
  // created () {
  //   this.$loading.show()
  // },
  destroyed () {
    this.$loading.hide() // 销毁页面关闭全局loading组件
  }
})

new Vue({
  store,
  router,
  created: bootstrap,
  render: h => h(App)
}).$mount('#app')
